<template>
  <div
    v-if="articleBar !== null"
    class="d-flex flex-wrap"
  >
    <article-card
      v-for="article in articleBar"
      :key="article.id"
      :is-overlay-type="true"
      :article="article"
      class="col-12 col-md-6 my-2"
    />
  </div>
</template>

<script>
import Axios from 'axios'

export default {
  name: 'articleBar',
  components: {
    'article-card': () => import(/* webpackChunkName: "ArticleCard" */ '../ArticleCard/ArticleCard.vue'),
  },
  props: {
    /**
     * article bar tipusa
     */
    type: {
      type: String,
      required: true,
    },
    /**
     * tag ami alapján lehet a tag typeot használni
     */
    tag: {
      type: String,
      default: null,
    },
    /**
     * article id lista
     */
    articleIdList: {
      type: String,
      default: null,
    },
    /**
     * article limit
     */
    limit: {
      type: Number,
      default: null,
    },
    /**
     * article id amit nem akarunk visszakapni a listába
     * mert pl cikk végoldalon van, és nem akarjuk a jelenlegi cikket ajánlani
     */
    skipArticleId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      /**
       * cikkek listája amiket kirenderelünk
       */
      articleBar: null,
    }
  },
  created() {
    this.getArticleBar()
  },
  methods: {
    /**
     * article lista lekérése
     */
    getArticleBar() {
      Axios.post('/Article/api/getArticleBar', {
        type: this.type,
        tag: this.tag,
        limit: this.limit,
        articleIdList: this.articleIdList,
        skipArticleId: this.skipArticleId,
      })
        .then(({ data }) => {
          this.articleBar = data
        })
        .catch((error) => {
          console.error(error)
        })
    },
  },
}
</script>
